import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "question-title"
}
const _hoisted_2 = {
  key: 1,
  class: "question-title"
}
const _hoisted_3 = {
  key: 2,
  class: "score-badge"
}
const _hoisted_4 = { class: "score-detail" }
const _hoisted_5 = { class: "question-body-container" }
const _hoisted_6 = { class: "footer-navigation" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]

import { ref, computed, watch } from 'vue'
import Question from '../models/Question'
import { LETTER_FORMAT } from '../../client/utils/constants'
import QuestionBodyComponent from './QuestionBodyComponent.vue'
import ProgressRotate from '../../client/components/atoms_molecules/ProgressRotate.vue'
import ChartProgress from '../../client/components/atoms_molecules/ChartProgress.vue'
import { qEditorState } from '../stores'


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionComponent',
  setup(__props) {

const reRender = ref(Date().toString())
const time = ref(20)
const score = ref(0)
const totalScore = ref(0)
const isAnswered = ref(false)

const questions = computed(() => qEditorState.questions)
const currentPage = computed(() => qEditorState.displayCurrentPage)
const question = computed(() => qEditorState.question)

watch(question, () => {
  onUnAnswer()
})

const groupQuestions = computed<Question[]>(() => {
  if (!question.value) return []
  const groupQuestionsList = questions.value.filter(q => question.value!.group == q.group)
  return groupQuestionsList
})

const questionsIgnoreDescription = computed<Question[]>(() => {
  return questions.value.filter((q) => !q.isDescriptionQuestion)
})

const groupNumber = computed(() => {
  const groupList: number[] = []
  questionsIgnoreDescription.value.forEach((q) => {
    if (groupList.indexOf(q.group) < 0) {
      groupList.push(q.group)
    }
  })
  return groupList.indexOf(question.value!.group)
})

const questionNumber = computed(() => {
  return questions.value.indexOf(question.value!) + 1
})

const totalQuestionNumber = computed(() => {
  return questions.value.length
})

const groupQuestionSize = computed(() => {
  return groupQuestions.value.length
})

const isSingleQuestion = computed(() => {
  return groupQuestionSize.value === 1
})

const onAnswerQuestion = (questionScore: number, questionTotalScore: number) => {
  score.value += questionScore
  totalScore.value += questionTotalScore
}

const first = () => {
  qEditorState.changePage({ page: 1 })
}

const previous = () => {
  qEditorState.changePage({ page: currentPage.value - 1 })
}

const next = () => {
  qEditorState.changePage({ page: currentPage.value + 1 })
}

const last = () => {
  qEditorState.changePage({ page: totalQuestionNumber.value })
}

const onAnswer = () => {
  isAnswered.value = true
}

const onUnAnswer = () => {
  score.value = 0
  totalScore.value = 0
  isAnswered.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!

  return (question.value)
    ? (_openBlock(), _createElementBlock("div", {
        class: "question-screen",
        key: reRender.value
      }, [
        _createVNode(_component_v_card, {
          class: "question-card",
          elevation: "0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "question-header" }, {
              default: _withCtx(() => [
                (question.value.isDescriptionQuestion)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('question.description', { format: _unref(LETTER_FORMAT).UPTITLECASE })), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(`${_ctx.$t('question.problem', { format: _unref(LETTER_FORMAT).UPTITLECASE })} ${groupNumber.value + 1}`), 1 /* TEXT */)),
                _createVNode(_component_v_spacer),
                (isAnswered.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                      _createTextVNode(_toDisplayString(Math.round((score.value * 100) / totalScore.value)) + "% ", 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_4, "（" + _toDisplayString(score.value) + "/" + _toDisplayString(totalScore.value) + "点）", 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createVNode(ProgressRotate, {
                  score: 40,
                  value: (time.value * 100) / 60,
                  color: '#2699fb',
                  width: 12,
                  size: 28,
                  showLable: false
                }, null, 8 /* PROPS */, ["value"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_divider),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupQuestions.value, (currentQuestion, index) => {
                return (_openBlock(), _createBlock(QuestionBodyComponent, {
                  question: currentQuestion,
                  questionNumber: index + 1,
                  totalQuestionNumber: totalQuestionNumber.value,
                  onOnAnswer: onAnswerQuestion,
                  isAnswered: isAnswered.value,
                  key: currentQuestion.id,
                  totalQuestion: groupQuestions.value.length
                }, null, 8 /* PROPS */, ["question", "questionNumber", "totalQuestionNumber", "isAnswered", "totalQuestion"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createVNode(_component_v_divider),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "nav-btn",
                onClick: first,
                disabled: questionNumber.value <= 1
              }, [
                _createVNode(_component_v_icon, { size: "small" }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-chevron-double-left", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                _cache[1] || (_cache[1] = _createTextVNode(" 最初 ", -1 /* CACHED */))
              ], 8 /* PROPS */, _hoisted_7),
              _createElementVNode("button", {
                class: "nav-btn",
                onClick: previous,
                disabled: questionNumber.value <= 1
              }, [
                _createVNode(_component_v_icon, { size: "small" }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("mdi-chevron-left", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                _cache[3] || (_cache[3] = _createTextVNode(" 前へ ", -1 /* CACHED */))
              ], 8 /* PROPS */, _hoisted_8),
              (!question.value.isDescriptionQuestion)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (!isAnswered.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "nav-btn answer-btn",
                          onClick: onAnswer
                        }, _toDisplayString(_ctx.$t('common.answer', { format: _unref(LETTER_FORMAT).UPTITLECASE })), 1 /* TEXT */))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "nav-btn unanswer-btn",
                          onClick: onUnAnswer
                        }, _toDisplayString(_ctx.$t('common.un_answer', { format: _unref(LETTER_FORMAT).UPTITLECASE })), 1 /* TEXT */))
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                class: "nav-btn",
                onClick: next,
                disabled: questionNumber.value >= totalQuestionNumber.value
              }, [
                _cache[5] || (_cache[5] = _createTextVNode(" 次へ ", -1 /* CACHED */)),
                _createVNode(_component_v_icon, { size: "small" }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("mdi-chevron-right", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ], 8 /* PROPS */, _hoisted_9),
              _createElementVNode("button", {
                class: "nav-btn",
                onClick: last,
                disabled: questionNumber.value >= totalQuestionNumber.value
              }, [
                _cache[7] || (_cache[7] = _createTextVNode(" 最後 ", -1 /* CACHED */)),
                _createVNode(_component_v_icon, { size: "small" }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("mdi-chevron-double-right", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ], 8 /* PROPS */, _hoisted_10)
            ])
          ]),
          _: 1 /* STABLE */
        })
      ]))
    : _createCommentVNode("v-if", true)
}
}

})